import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const equipmentMountManRepository = RepositoryFactory.get("equipmentMountMan");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setRegisteredEquipmentMountMan(state, payload) {
    state.registeredData = payload;
  },
  setSuccessObject(state, payload) {
    state.successObject = payload;
  }
};
const actions = {
  async entryEquipmentMountMan(context, payload) {
    const requestParameter = {
      car_id: payload.car_id,
      equipment_id: payload.equipment.equipment_id,
      quantity: payload.equipment.equipment_quantity
    };
    const equipmentMountMans = await equipmentMountManRepository.entry(
      payload.screenId,
      requestParameter
    );
    if (equipmentMountMans.status < 300) {
      context.commit("setRegisteredEquipmentMountMan", equipmentMountMans.data);
      context.commit("setSuccessObject", equipmentMountMans);
    }
  },
  async updateEquipmentMountMan(context, payload) {
    const requestParameter = {
      equipment_man_id: payload.equipment.equipment_man_id,
      quantity: payload.equipment.equipment_quantity,
      modified_hash: payload.equipment.modified_hash
    };
    const equipmentMountMans = await equipmentMountManRepository.update(
      payload.screenId,
      requestParameter
    );
    if (equipmentMountMans.status < 300) {
      context.commit("setRegisteredEquipmentMountMan", equipmentMountMans.data);
      context.commit("setSuccessObject", equipmentMountMans);
    }
  },
  async deleteEquipmentMountMan(context, payload) {
    const requestParameter = {
      equipment_man_id: payload.equipment.equipment_man_id,
      modified_hash: payload.equipment.modified_hash
    };
    const equipmentMountMans = await equipmentMountManRepository.delete(
      payload.screenId,
      requestParameter
    );
    if (equipmentMountMans.status < 300) {
      context.commit("setSuccessObject", equipmentMountMans);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
